export type PrefillMode = 'editable' | 'disabled' | 'hidden';

export interface PrefillValue {
    value: string;
    mode: PrefillMode;
}

export interface PrefillConfig {
    [recrastype: string]: PrefillValue;
}

export function normalizePrefillData(raw: string | null | undefined): Map<string, PrefillValue> {
    const result = new Map<string, PrefillValue>();

    if (!raw) {
        return result;
    }

    let parsed: any;
    try {
        parsed = JSON.parse(raw);
    } catch (e) {
        console.warn(
            '[Recras Bookprocess] Invalid prefill data: Unable to parse JSON in data-prefill attribute'
        );
        return result;
    }

    if (typeof parsed !== 'object' || parsed === null) {
        console.warn(
            '[Recras Bookprocess] Invalid prefill data: Expected object, got ' + typeof parsed
        );
        return result;
    }

    for (const [recrastype, config] of Object.entries(parsed)) {
        if (typeof config === 'string') {
            result.set(recrastype, {
                value: config,
                mode: 'editable',
            });
        } else if (typeof config === 'object' && config !== null) {
            const configObj = config as any;
            if (!configObj.value) {
                console.warn(
                    `[Recras Bookprocess] Invalid prefill data for '${recrastype}': Missing value`
                );
                continue;
            }

            let mode: PrefillMode = 'editable';
            if (configObj.mode) {
                if (['editable', 'disabled', 'hidden'].includes(configObj.mode)) {
                    mode = configObj.mode as PrefillMode;
                } else {
                    console.warn(
                        `[Recras Bookprocess] Invalid mode '${configObj.mode}' for '${recrastype}', defaulting to 'editable'`
                    );
                }
            }

            result.set(recrastype, {
                value: String(configObj.value),
                mode: mode,
            });
        } else {
            console.warn(
                `[Recras Bookprocess] Invalid prefill data for '${recrastype}': Expected string or object, got ${typeof config}`
            );
        }
    }

    return result;
}
